import { Controller } from "@hotwired/stimulus"

const debug = true

export default class extends Controller {
  static values = {
    formId: String,
  }

  submit() {
    if (debug) console.info("ClickSubmit::submit")
    const form = document.getElementById(this.formIdValue)

    if (form) {
      form.requestSubmit()
    }
  }
}